import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { ColorsEnum, Text } from './text';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'mt-auto flex w-full px-7 py-12 font-light',
        PaletteUtils.isVcfcPalette && 'bg-twilight-dusk dark:bg-gray-brown',
        PaletteUtils.isInsigniaPalette && 'bg-very-pale-green dark:bg-gray-brown',
      )}
    >
      <div className='mx-auto flex max-w-[762px] flex-col gap-6 text-center'>
        <Text color={PaletteUtils.getColor(undefined, ColorsEnum.White)}>
          {t('footer.licensed')} <br />
          {t('footer.address')}
        </Text>
        <Text color={PaletteUtils.getColor(undefined, ColorsEnum.White)}>{t('footer.help')}</Text>
      </div>
    </div>
  );
};
